import { SET_COLUMNS } from '../actions/session';

export default function (state = {}, action) {
  switch (action.type) {
  case SET_COLUMNS:
    return { ...state, currentColumns: action.columns };
  default:
    return state;
  }
}
